module.exports = __webpack_public_path__ + "img/magento-version-switching@2x.db485fbc.jpg";